// www/src/components/ThemeSwitcher.js
import React from 'react';
import { THEMES } from '../themes/themes';
import './ThemeSwitcher.css';

export default function ThemeSwitcher({ value, onChange }) {
  return (
    <div className="theme-switcher">
      <label className="theme-switcher-label">
        Active Theme
        <select
          className="theme-switcher-select"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {THEMES.map((t) => (
            <option key={t.key} value={t.key}>{t.label}</option>
          ))}
        </select>
      </label>
      <div className="theme-switcher-previews">
        {THEMES.map((t) => (
          <a
            key={t.key}
            className="theme-preview-link"
            href={`/?theme=${t.slug}`}
            target="_blank"
            rel="noreferrer"
          >
            Preview {t.label}
          </a>
        ))}
      </div>
    </div>
  );
}
